var K = {
  ce: function ce() {
    var t = function t() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var n = (Math.random().toString(16) + "000000000").substr(2, 8);
      return t ? "-" + n.substr(0, 4) + "-" + n.substr(4, 4) : n;
    };

    return t() + t(!0) + t(!0) + t();
  }
};
export default K;